const report = (...args: unknown[]): void => {
  args.forEach(console.error);
};

export default report;
